<div class="pt-3" *ngIf="userNotFound">
  <h2>Staff User Not Found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 mb-6" *ngIf="!userNotFound && (serverError === null)">
  <h2 class="mb-4">{{ isNewUser ? 'Add A New Staff User' : 'Edit Staff User' }}</h2>

  <div class="row">

    <div class="col-md-6">
      <h4>Staff User Info</h4>

      <form (submit)="onUserInfoSubmit(false)">

        <div class="form-group">
          <label for="user_type">User Type</label>
          <select id="user_type" name="user_type"
                  class="custom-select" type="text"
                  [disabled]="!isNewUser"
                  [class.disabled]="!isNewUser"
                  [(ngModel)]="user.user_type"
                  (ngModelChange)="unsavedChanges = true; clearNameAndEmail();">
            <option [ngValue]="UserType.staffMember">Staff Member</option>
            <option [ngValue]="UserType.apiIntegration">API Integration</option>
          </select>
          <div class="form-text text-danger">{{ userInfoErrors.user_type }}</div>
        </div>

        <ng-container *ngIf="user.user_type === UserType.staffMember">

          <div class="form-group">
            <label for="firstNameInput">First Name</label>
            <input id="firstNameInput" type="text" class="form-control" name="firstName"
                   [(ngModel)]="user.first_name"
                   (ngModelChange)="unsavedChanges = true">
            <div class="form-text text-danger">{{ userInfoErrors.first_name }}</div>
          </div>

          <div class="form-group">
            <label for="lastNameInput">Last Name</label>
            <input id="lastNameInput" type="text" class="form-control" name="lastName"
                   [(ngModel)]="user.last_name"
                   (ngModelChange)="unsavedChanges = true">
            <div class="form-text text-danger">{{ userInfoErrors.last_name }}</div>
          </div>

          <div class="form-group">
            <label for="emailInput">Email</label>
            <input id="emailInput" type="text" class="form-control" name="email"
                   [(ngModel)]="user.email"
                   (ngModelChange)="unsavedChanges = true">
            <small class="form-text text-muted">
              Email is optional, but without one a user will be unable to log in to the Staff Site. We recommend the use of work emails for staff member accounts. This email may also be associated with a customer account, however there may not be another staff member with the same email (even in a different organization).
            </small>
            <div class="form-text text-danger">{{ userInfoErrors.email }}</div>
          </div>

        </ng-container>

        <ng-container *ngIf="user.user_type === UserType.apiIntegration">

          <div class="form-group">
            <label for="nameInput">Name</label>
            <input id="nameInput" type="text" class="form-control" name="name"
                   [(ngModel)]="user.first_name"
                   (ngModelChange)="unsavedChanges = true">
            <div class="form-text text-danger">{{ userInfoErrors.first_name }}</div>
          </div>

        </ng-container>

        <ng-container *ngIf="user.user_type === UserType.staffMember">

          <div class="form-group form-check mb-1">
            <input type="checkbox" class="form-check-input"
                   id="pinModeRequiredInput" name="pinModeRequired"
                   [(ngModel)]="user.pin_mode_required"
                   (ngModelChange)="unsavedChanges = true">
            <label class="form-check-label" for="pinModeRequiredInput">PIN Mode Required?</label>
            <div class="form-text text-danger">{{ userInfoErrors.pin_mode_required }}</div>
          </div>
          <p class="text-muted">If this is selected, then the user may only log into the Staff Site if the "Require PINs when making changes" option is selected.</p>

          <div class="form-group form-check mb-1">
            <input type="checkbox" class="form-check-input"
                   id="can_log_in_to_staff_site"
                   name="can_log_in_to_staff_site"
                   [(ngModel)]="user.can_log_in_to_staff_site"
                   (ngModelChange)="unsavedChanges = true">
            <label class="form-check-label" for="can_log_in_to_staff_site">
              Can Log In To Staff Site?
            </label>
            <div class="form-text text-danger">{{ userInfoErrors.can_log_in_to_staff_site }}</div>
          </div>
          <p class="text-muted">
            Whether the user may log in to the Staff Site. This permission is also required in order to log into the Check-In and Check-Out Sites.
          </p>

        </ng-container>

        <div class="form-group form-check mb-1">
          <input type="checkbox" class="form-check-input"
                 id="canManageEvents" name="canManageEvents"
                 [(ngModel)]="user.can_manage_events"
                 (ngModelChange)="unsavedChanges = true">
          <label class="form-check-label" for="canManageEvents">Can Manage Events?</label>
          <div class="form-text text-danger">{{ userInfoErrors.can_manage_events }}</div>
        </div>
        <p class="text-muted">Whether the user may access the Event Setup section of this site.</p>

        <div class="form-group form-check mb-1">
          <input type="checkbox" class="form-check-input"
                 id="canManageMembers" name="canManageMembers"
                 [(ngModel)]="user.can_manage_members"
                 (ngModelChange)="unsavedChanges = true">
          <label class="form-check-label" for="canManageMembers">Can Manage Customers?</label>
          <div class="form-text text-danger">{{ userInfoErrors.can_manage_members }}</div>
        </div>
        <p class="text-muted">Whether the user may access the Customers section of this site.</p>

        <ng-container *ngIf="user.can_manage_members">
          <div class="form-group form-check mb-1">
            <input type="checkbox" class="form-check-input"
                   id="canManageCustomerProficiencies" name="canManageCustomerProficiencies"
                   [(ngModel)]="user.can_manage_customer_proficiencies"
                   (ngModelChange)="unsavedChanges = true">
            <label class="form-check-label" for="canManageCustomerProficiencies">Can Manage Customer Proficiencies?</label>
            <div class="form-text text-danger">{{ userInfoErrors.can_manage_customer_proficiencies }}</div>
          </div>
          <p class="text-muted">Whether the user may edit the proficiencies on a customer's profile.</p>
        </ng-container>

        <ng-container *ngIf="user.can_manage_members && (user.user_type === UserType.staffMember)">
          <div class="form-group form-check mb-1">
            <input type="checkbox" class="form-check-input"
                   id="canExportCustomers" name="canExportCustomers"
                   [(ngModel)]="user.can_export_customers"
                   (ngModelChange)="unsavedChanges = true">
            <label class="form-check-label" for="canExportCustomers">Can Export Customer List?</label>
            <div class="form-text text-danger">{{ userInfoErrors.can_export_customers }}</div>
          </div>
          <p class="text-muted">Whether the user may use the Export function in the Customers section of this site.</p>
        </ng-container>

        <div class="form-group form-check mb-1">
          <input type="checkbox" class="form-check-input"
                 id="canAccessReports" name="canAccessReports"
                 [(ngModel)]="user.can_access_reports"
                 (ngModelChange)="unsavedChanges = true">
          <label class="form-check-label" for="canAccessReports">Can Access Reports?</label>
          <div class="form-text text-danger">{{ userInfoErrors.can_access_reports }}</div>
        </div>
        <p class="text-muted">Whether the user may access the Reporting section of this site.</p>

        <ng-container *ngIf="user.user_type === UserType.apiIntegration">

          <div class="form-group form-check mb-1">
            <input type="checkbox" class="form-check-input"
                   id="has_griptonite_access" name="has_griptonite_access"
                   [(ngModel)]="user.has_griptonite_access"
                   (ngModelChange)="unsavedChanges = true">
            <label class="form-check-label" for="has_griptonite_access">Has Griptonite Access?</label>
            <div class="form-text text-danger">{{ userInfoErrors.has_griptonite_access }}</div>
          </div>
          <p class="text-muted">
            Whether the user has access required for a Griptonite integration. This grants read-only access to customer data, as well as the ability to configure webhooks.
          </p>

          <div class="form-group form-check mb-1">
            <input type="checkbox" class="form-check-input"
                   id="can_look_up_members_by_barcode"
                   name="can_look_up_members_by_barcode"
                   [(ngModel)]="user.can_look_up_members_by_barcode"
                   (ngModelChange)="unsavedChanges = true">
            <label class="form-check-label" for="can_look_up_members_by_barcode">
              Can Look Up Members By Barcode?
            </label>
            <div class="form-text text-danger">
              {{ userInfoErrors.can_look_up_members_by_barcode }}
            </div>
          </div>
          <p class="text-muted">
            Whether the user can access the
            <a href="{{ apiUrl }}docs/look-up-member-by-barcode/" target="_blank">
              Look Up Members By Barcode API endpoint
            </a>.
            This is intended for integrations which need to be able to look up and verify the details of a member of
            your organization, but which should not have access to any other data.
          </p>

        </ng-container>

        <div class="form-group form-check mb-1">
          <input type="checkbox" class="form-check-input"
                 id="isOrganizationAdmin" name="isOrganizationAdmin"
                 [(ngModel)]="user.is_organization_admin"
                 (ngModelChange)="unsavedChanges = true">
          <label class="form-check-label" for="isOrganizationAdmin">Is Organization Admin?</label>
          <div class="form-text text-danger">{{ userInfoErrors.is_organization_admin }}</div>
        </div>
        <p class="text-muted">Whether the user may administer this organization. Needed to access Staff Admin, as well as configuration pages such as Document Templates and Linking Accounts.</p>

        <div class="alert alert-info" role="alert"
             *ngIf="user.user_type === UserType.staffMember">
          When using PIN mode, the logged-in user's permissions determine what data can be read and exported. For any operations which edit data, a PIN must be entered, and the PIN user's permissions will determine whether the edit is allowed.
        </div>

        <div class="alert alert-danger" role="alert" *ngIf="userInfoErrors.non_field_errors">
          {{ userInfoErrors.non_field_errors }}
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="userInfoErrorMessage">
          {{ userInfoErrorMessage }}
        </div>

        <div class="alert alert-info" role="alert"
             *ngIf="loadingUser || loadingSubmitUserInfo">
          Loading...
        </div>

        <div class="alert alert-success" role="alert" *ngIf="userInfoSuccessMessage">
          {{ userInfoSuccessMessage }}
        </div>

        <!-- Place save button first so that the enter key press activates it -->
        <div class="float-right">
          <button type="submit" class="btn btn-primary mb-3"
                  [disabled]="isLoading()"
                  [class.disabled]="isLoading()">
            Save
          </button>
        </div>
        <button routerLink="/users" class="btn btn-secondary mb-3"
                [class.mr-2]="!isNewUser">
          {{ isNewUser ? 'Cancel' : 'Back' }}
        </button>
      </form>
    </div>

    <div class="col-md-5 offset-md-1 mt-md-0 mt-4" *ngIf="!isNewUser">

      <ng-container *ngIf="user.user_type === UserType.staffMember">

        <h4>
          Pin Status:
          <span *ngIf="user.has_pin" class="text-success">Has Pin</span>
          <span *ngIf="!user.has_pin" class="text-danger">Does Not Have Pin</span>
        </h4>

        <button type="submit" class="btn btn-danger mb-3"
                *ngIf="user.has_pin"
                (click)="removePin()">
          Remove Pin
        </button>

        <p class="text-muted">
          A PIN is needed for clock-in/out, as well as when using the Staff Site with PIN mode active.
        </p>

        <div class="alert alert-danger" role="alert" *ngIf="removePinErrorMessage">
          {{ removePinErrorMessage }}
        </div>

        <div class="alert alert-info" role="alert" *ngIf="loadingRemovePin">
          Loading...
        </div>

        <div class="alert alert-success" role="alert" *ngIf="removePinSuccessMessage">
          {{ removePinSuccessMessage }}
        </div>

        <hr>

        <h4>{{ user.has_pin ? 'Update' : 'Add' }} Pin</h4>

        <form>

          <div class="form-group">
            <label for="newPinInput">New Pin</label>
            <input id="newPinInput" type="password"
                   class="form-control" name="newPin"
                   [(ngModel)]="newPin">
            <div class="form-text text-danger">{{ setPinErrors.new_pin }}</div>
          </div>

          <div class="form-group">
            <label for="newPinRepeatInput">Repeat New Pin</label>
            <input id="newPinRepeatInput" type="password"
                   class="form-control" name="newPinRepeat"
                   [(ngModel)]="newPinConfirm">
            <div class="form-text text-danger">{{ setPinErrors.new_pin_confirm }}</div>
          </div>

          <div class="alert alert-danger" role="alert" *ngIf="setPinErrors.non_field_errors">
            {{ setPinErrors.non_field_errors }}
          </div>
          <div class="alert alert-danger" role="alert" *ngIf="setPinErrorMessage">
            {{ setPinErrorMessage }}
          </div>

          <div class="alert alert-info" role="alert" *ngIf="loadingSetPin">
            Loading...
          </div>

          <div class="alert alert-success" role="alert" *ngIf="setPinSuccessMessage">
            {{ setPinSuccessMessage }}
          </div>

          <button type="submit" class="btn btn-primary mb-3 float-right" (click)="setPin()">
            Set Pin
          </button>
          <button class="btn btn-secondary mb-3" (click)="resetSetPinInput()">
            Cancel
          </button>

        </form>

        <hr>

        <h4>
          Password Status:
          <span *ngIf="user.has_password" class="text-success">Has Password</span>
          <span *ngIf="!user.has_password" class="text-danger">Does Not Have Password</span>
        </h4>

        <button type="submit" class="btn btn-danger mb-3"
                *ngIf="user.has_password"
                [disabled]="isLoading()"
                [class.disabled]="isLoading()"
                (click)="removePassword()">
          Remove Password
        </button>

        <p class="text-muted">
          A password, in addition to an email address, is required in order for the staff member to log in to the Staff Site.
        </p>

        <div class="alert alert-danger" role="alert" *ngIf="removePasswordErrorMessage">
          {{ removePasswordErrorMessage }}
        </div>

        <div class="alert alert-info" role="alert" *ngIf="loadingRemovePassword">
          Loading...
        </div>

        <div class="alert alert-success" role="alert" *ngIf="removePasswordSuccessMessage">
          {{ removePasswordSuccessMessage }}
        </div>

        <button type="button" class="btn btn-primary"
                [disabled]="isLoading() || (getSetPasswordEmailTooltip() !== '')"
                [class.disabled]="isLoading() || (getSetPasswordEmailTooltip() !== '')"
                [ngbTooltip]="getSetPasswordEmailTooltip()"
                (click)="handlePasswordResetEmailSubmit()">
          Send Email to {{ user.has_password ? 'Reset' : 'Set' }} Password
        </button>

        <div class="alert alert-danger mt-2" role="alert" *ngIf="resetPasswordEmailErrorMessage">
          {{ resetPasswordEmailErrorMessage }}
        </div>

        <div class="alert alert-info mt-2" role="alert" *ngIf="loadingSendResetPasswordEmail">
          Loading...
        </div>

        <div class="alert alert-success mt-2" role="alert" *ngIf="resetPasswordEmailSuccessMessage">
          {{ resetPasswordEmailSuccessMessage }}
        </div>

        <hr>

        <h4>{{ user.has_password ? 'Update' : 'Add' }} Password</h4>

        <form>

          <div class="form-group">
            <label for="newPasswordInput">New Password</label>
            <input id="newPasswordInput" type="password"
                   class="form-control" name="newPassword"
                   [(ngModel)]="newPassword">
            <div class="form-text text-danger">{{ setPasswordErrors.new_password }}</div>
          </div>

          <div class="form-group">
            <label for="newPasswordRepeatInput">Repeat New Password</label>
            <input id="newPasswordRepeatInput" type="password"
                   class="form-control" name="newPasswordRepeat"
                   [(ngModel)]="newPasswordConfirm">
            <div class="form-text text-danger">{{ setPasswordErrors.new_password_confirm }}</div>
          </div>

          <div class="alert alert-danger" role="alert" *ngIf="setPasswordErrors.non_field_errors">
            {{ setPasswordErrors.non_field_errors }}
          </div>
          <div class="alert alert-danger" role="alert" *ngIf="setPasswordErrorMessage">
            {{ setPasswordErrorMessage }}
          </div>

          <div class="alert alert-info" role="alert" *ngIf="loadingSetPassword">
            Loading...
          </div>

          <div class="alert alert-success" role="alert" *ngIf="setPasswordSuccessMessage">
            {{ setPasswordSuccessMessage }}
          </div>

          <button type="submit" class="btn btn-primary mb-3 float-right"
                  [disabled]="isLoading()"
                  [class.disabled]="isLoading()"
                  (click)="setPassword()">
            Set Password
          </button>
          <button class="btn btn-secondary mb-3" (click)="resetSetPasswordInput()">
            Cancel
          </button>

        </form>

        <hr>

        <h4>
          Two-Factor Authentication:
          <span class="text-success" *ngIf="user.otp_enabled">Enabled</span>
          <span class="text-danger" *ngIf="!user.otp_enabled">Disabled</span>
        </h4>

        <button type="button" class="btn btn-danger"
                *ngIf="user.otp_enabled"
                (click)="openDisableTwoFactorAuthModal()"
                [disabled]="loadingDisableTwoFactorAuth"
                [class.disabled]="loadingDisableTwoFactorAuth">
          {{ loadingDisableTwoFactorAuth ? 'Loading...' : 'Disable 2FA' }}
        </button>

        <div class="alert alert-info mt-3"
             *ngIf="!user.otp_enabled">
          A Staff Site user may enable two-factor authentication by logging in to the Staff Site and navigating to
          <a routerLink="/account-settings">
            Account Settings
          </a>.
        </div>

        <ng-container *ngIf="orgConfig && orgConfig.pos_software === OrgPOSSoftware.lightspeed">

          <hr>

          <h4>
            Lightspeed User Account:
            <span class="text-success" *ngIf="user.lightspeed_user_id !== ''">Linked</span>
            <span class="text-danger" *ngIf="user.lightspeed_user_id === ''">Unlinked</span>
          </h4>

          <p *ngIf="user.lightspeed_user_id !== ''">
            Username:
            <b>{{ user.lightspeed_user_username }}</b>
            <br>
            Display Name:
            <b>{{ user.lightspeed_user_display_name }}</b>
            <br>
            Lightspeed ID:
            <b>{{ user.lightspeed_user_id }}</b>
          </p>

          <button type="submit" class="btn btn-primary mb-3"
                  *ngIf="user.has_pin"
                  (click)="openSetLightspeedUserModal()">
            Configure Linked Lightspeed User
          </button>

        </ng-container>

      </ng-container>

      <ng-container *ngIf="user.user_type === UserType.apiIntegration">

        <button class="btn btn-primary"
                *ngIf="apiToken === null"
                [disabled]="loadingAPIToken"
                [class.disabled]="loadingAPIToken"
                (click)="loadAPIToken()">
          {{ loadingAPIToken ? 'Loading...' : 'Show API Token' }}
        </button>

        <div *ngIf="apiToken !== null"
             class="bg-light border-rounded-10 p-2">
          API Token: <br>
          <b>{{ apiToken }}</b>
        </div>

        <div class="alert alert-danger mt-2" role="alert"
             *ngIf="getAPITokenErrorMessage">
          {{ getAPITokenErrorMessage }}
        </div>

      </ng-container>

    </div>

  </div>
</div>
